import React, { createContext, useContext, useState, useEffect } from "react";
import Cookies from "js-cookie";
import { GetProfile } from "../ProfileData.ts";

const ProfileContext = createContext();

export const useProfile = () => useContext(ProfileContext);

export const ProfileProvider = ({ children }) => {
    const [profile, setProfile] = useState({
        id: "",
        email: "",
        firstName: "",
        lastName: "",
        category: "",
        budget: "",
        rate: "",
        rateCount: "",
        rate_Skill_1: "",
        rate_Skill_2: "",
        rate_Skill_3: "",
        rate_Skill_4: "",
        rate_Skill_5: "",
        role: "",
        auth: {
            id: "",
            userId: "",
            password: "",
            refreshToken: "",
            refreshTokenExpiration: "",
            user: null,
        },
        contacts: [
            {
                id: "",
                userId: "",
                contactInfo: "",
                category: "",
                isPublic: "",
                user: null,
            },
        ],
        deposits: null,
        purchases: null,
        profile: {
            id: "",
            userId: "",
            userName: "",
            birthDate: "",
            gender: "",
            profilePicture: "",
            profileCoverPicture: "",
            pinEnabled: false,
            pinVersion: 0,
            hasPin: false,
        },
    });

    useEffect(() => {
        fetchProfile();
    }, []);

    const fetchProfile = async () => {
        if (!Cookies.get("authToken")) return;
        const response = await GetProfile();
        const profileData = response?.data;
        if (profileData && profileData.category) {
            localStorage.setItem("userCategory", profileData.category);
        }
        setProfile(profileData);
    };

    return (
        <ProfileContext.Provider value={{ profile, setProfile, fetchProfile }}>
            {children}
        </ProfileContext.Provider>
    );
};
